<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col col="12">
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <div>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  dense
                  :headers="headers"
                  :items="prepareData"
                  item-key="name"
                  class="elevation-3"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-spacer></v-spacer>
                      <v-dialog
                        v-model="dialog"
                        max-width="600px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $t('actions.new') }}
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                >
                                  <v-menu
                                    v-model="datetime"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        :value="formDateFormatted"
                                        @input="changeDate('datetime', $event)"
                                        :label="lang($store, 'sap/listings.global.filter.hints.date')"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="editedItem.datetime" no-title
                                                   :first-day-of-week="1"
                                                   :locale="getCurrentLanguage()"
                                                   @input="datetime = false"></v-date-picker>
                                  </v-menu>

                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="editedItem.sum"
                                    :label="lang($store, 'sap/listings.global.filter.hints.sum')"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-select
                                    v-model="editedItem.type"
                                    :label="lang($store, 'sap/listings.global.filter.hints.type')"
                                    :items="cashierPaymentTypes"
                                    persistent-hint
                                    single-line
                                    :loading="false"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                >
                                  <v-text-field
                                    v-model="editedItem.note"
                                    :label="lang($store, 'sap/listings.global.filter.hints.info')"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="close"
                            >
                              {{ $t('actions.cancel') }}
                            </v-btn>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="save"
                            >
                              {{ $t('actions.save') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogDelete" max-width="600px">
                        <v-card>
                          <v-card-title class="headline">{{ $t('cashier.modal.delete') }}</v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">{{ $t('actions.cancel') }}</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">{{ $t('actions.ok') }}</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-card
                      v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
                      class="pa-3">
                      <p class="text-center mt-2">
                        <v-icon>mdi-account-search-outline</v-icon>
                        <b>&nbsp;&nbsp;{{ lang($store, 'sap/listings.incomes.not_found') }}&nbsp;&nbsp;</b>
                        <v-icon>mdi-account-badge-outline</v-icon>
                      </p>
                    </v-card>
                  </template>
                  <template v-slot:body.append v-if="isTopManager">
                    <tr>
                      <td>
                        <span
                          class="font-weight-bold"
                        >
                          Всего
                        </span>
                        <v-divider
                          class="mx-4"
                          inset
                          vertical
                        ></v-divider>
                        <span
                          class="font-weight-bold"
                        >
                           {{ getResult }}
                        </span>
                      </td>
                      <td>
                      </td>
                      <td colspan="4"></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" v-if="isTopManager">
                <v-data-table
                  dense
                  :headers="totalsHeaders"
                  :items="prepareTotals"
                  item-key="name"
                  class="elevation-3"
                  hide-default-footer
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-toolbar-title>{{ $t('cashier.results') }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { MANAGER_TOP } from '@/constants/roles';
/* mixins */
import accountMixin from '@/mixins/accountMixin';
import isComponentLoading from '@/mixins/isComponentLoading';
import incomeDialog from '@/mixins/cashier/incomeDialog';
/* components */
import IncomesProxy from '@/proxies/Cashier/IncomesProxy';
import cashierPaymentTypes from '@/constants/cashier_payment_types';
import i18n from '@/i18n';


export default {
  name: 'TablePaginatedIncomes',
  components: {
    // IncomesProxy,
  },
  mixins: [
    accountMixin,
    isComponentLoading,
    incomeDialog,
  ],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    result: {
      type: Number,
      default: 0.00,
    },
    allTotals: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MANAGER_TOP,
      moment,
      dialog: false,
      currentItem: {},
      dialogDelete: false,
      L: _,
      incomesData: [],
      headers: [
        {
          text: i18n.t('table.headers.date'),
          value: 'datetime',
        },
        {
          text: i18n.t('table.headers.sum'),
          value: 'sum',
        },
        {
          text: i18n.t('table.headers.payment_type'),
          value: 'type_name',
        },
        {
          text: i18n.t('table.headers.info'),
          value: 'note',
        },
        {
          text: i18n.t('table.headers.actions'),
          value: 'actions',
          sortable: false,
        },
      ],
      totalsHeaders: [
        {
          text: i18n.t('table.headers.name'),
          value: 'name',
        },
        {
          text: i18n.t('table.headers.sum'),
          value: 'sum',
        },
      ],
      editedIndex: -1,
      editedItem: {
        datetime: '',
        sum: 0.00,
        type: '',
        type_name: '',
        note: '',
      },
      datetime: false,
      allResult: 0.00,
      allTotalsForPeriod: [],
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    cashierPaymentTypes() {
      const paymentTypes = [];
      Object.keys(cashierPaymentTypes.CASHIER)
        .forEach(key => {
          paymentTypes.push({
            text: this.lang(this.$store, `sap/listings.global.filter.payment_types.${cashierPaymentTypes.CASHIER[key]}`),
            value: cashierPaymentTypes.CASHIER[key],
          });
        });
      return paymentTypes;
    },
    prepareData() {
      if (this.paginatedObject && this.paginatedObject.data) {
        this.incomesData = this.paginatedObject.data.map(function (item) {
          return {
            datetime: item.datetime,
            note: item.note,
            sum: item.sum,
            type: item.type,
            type_name: item.type_name ? this.lang(this.$store, `sap/listings.global.filter.payment_types.${cashierPaymentTypes.CASHIER[item.type]}`) : 'не задан',
            uuid: item.uuid,
          };
        }, this);
      }
      return this.incomesData;
    },
    getResult() {
      if (this.result) {
        this.allResult = this.result;
      }
      return this.allResult;
    },
    prepareTotals() {
      if (this.allTotals && this.allTotals.data) {
        this.allTotalsForPeriod = this.allTotals.data.map(item => ({
          name: item.name,
          sum: item.sum,
        }), this);
      }
      return this.allTotalsForPeriod;
    },
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('cashier.modal.create') : i18n.t('cashier.modal.edit');
    },
    formDateFormatted() {
      return this.formatDate(this.editedItem.datetime);
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    editedItem: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    getCurrentLanguage() {
      return localStorage.getItem('language') || process.env.VUE_APP_DEFAULT_LANGUAGE;
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      new IncomesProxy()
        .destroy(this.editedItem.uuid)
        .catch(response => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.$store.dispatch('page/updateCurrentPageContent');
        });

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    save() {
      this.onActionIncomeDialog(this.editedItem);
      this.close();
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer
</style>
